import { get, post } from 'src/tools/server';
import { IFetchIventories } from './types';
const getProduct = (uuid?: string) => {
  const params = uuid ? { productUuid: uuid } : {};
  return get(`/portal/productPage`, { params: params });
};

const getInventories = (
  startIndex,
  pageCount,
  body,
): Promise<IFetchIventories> => {
  return post(
    `/portal/inventoryListPage/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const postInventories = (startIndex, pageCount, body) => {
  return post(
    `/portal/inventories/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const adjustInventory = (body) => {
  return post(`/portal/inventory/adjust`, body, {});
};
const inventoryDetails = (inventoryUuid, startIndex, pageCount) => {
  return get(
    `/portal/inventory/details/${inventoryUuid}/${startIndex || 0}/${
      pageCount || 10
    }`,
    {},
  );
};

const allInventoryDetails = (productUuid, startIndex, pageCount) => {
  return get(
    `/portal/inventory/allDetails/${productUuid}/${startIndex || 0}/${
      pageCount || 10
    }`,
    {},
  );
};

export {
  getProduct,
  postInventories,
  getInventories,
  adjustInventory,
  inventoryDetails,
  allInventoryDetails,
};
